module.exports = __webpack_public_path__ + "static/media/td.a50bd3ae.png";